import { getOperationName } from '@apollo/client/utilities';
import {
  GetAutomationsListDocument,
  GetAutomationParentAutomationsDocument,
  GetAutomationEditorDataDocument,
  GetGlobalAutomationsListDocument,
} from 'shared/types/graphql';

export const getAutomationsListQuery = getOperationName(GetAutomationsListDocument) || '';
export const getGlobalAutomationsListQuery = getOperationName(GetGlobalAutomationsListDocument) || '';
export const getAutomationEditorDataQuery = getOperationName(GetAutomationEditorDataDocument) || '';
export const getAutomationParentAutomationsQuery = getOperationName(GetAutomationParentAutomationsDocument) || '';
